<template>
  <v-container>
    <v-row 
      justify="center"
    >
      <v-col 
        cols="12"
        sm="12"
        md="12"
      >
        <v-card flat>
          <v-card-title class="mb-7 pt-0">
            <v-row
              justify="center"
            >
              <v-col
                cols="12"
                lg="6"
              >
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Rechercher une commande"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <v-data-table
            :loading="isLoading"
            loading-text="Chargement... Veuillez patienter"
            :headers="headers"
            :items="orders"
            :search="search"
            :custom-sort="customSort"
            :custom-filter="customFilter"
            :items-per-page="options.itemsPerPage"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50]
            }"
            locale="fr"
            @click:row="goToOrder()"
          >
            <template
              v-slot:item="{ item }"
            >
              <tr 
                class="clickable"
                @click="goToOrder(item.id)"
              >
                <td align="center">{{ item.id }}</td>
                <td class="text-xs-right">{{ item.customID }}</td>
                <td class="text-xs-right">{{ item.date.formatted }}</td>
                <td class="text-xs-right">
                  <v-chip 
                    :color="item.status.color" 
                    dark
                    class="fs12"
                    small
                  >{{ item.status.name }}</v-chip>
                </td>
                <td class="text-xs-right">
                  {{ item.etTotal | toPrice(2, '€') }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // EVENTS
  import { EventBus } from '@/main.js'
  import { AUTH_LOGOUT } from '@/store/actions/auth'
  import { LOADING, LOADED } from '@/store/actions/general'
  // REPOSITORIES
  import { RepositoryFactory } from '@/repositories/RepositoryFactory'
  const OrdersRepository = RepositoryFactory.get('orders')

  export default {
    name: 'List',

    data() {
      return {
        isLoading: false,
        search: '',
        headers: [
          { text: 'N° BRODELEC', value: 'id', align: 'center' },
          { text: 'N° COMMANDE', value: 'customID' },
          { text: 'DATE', value: 'date' },
          { text: 'STATUT', value: 'status' },
          { text: 'TOTAL HT', value: 'etTotal' },
        ],
        orders: [],
        options: {
          itemsPerPage: 50,
        }
      }
    },

    methods: {
      async getOrders() {
        this.isLoading = true
        let customerApiToken = this.$store.getters.getCustomer.apiToken
        await OrdersRepository
          .getOrders(customerApiToken)
          .then(response => {
            this.isLoading = false
            this.orders    = response.data
            EventBus.$emit(LOADED)
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 403) {
                this.$store
                  .dispatch(AUTH_LOGOUT)
                  .then(() => {
                    this.$router.push('/login').catch(err => {})
                  })
              }
            }
          })
      },
      customSort(items, index, isDesc) {
        items.sort((a, b) => {
          if (index[0] === 'id') {
            if (!isDesc[0]) {
              return parseInt(a.id) - parseInt(b.id)
            } else {
              return parseInt(b.id) - parseInt(a.id)
            }
          } else if (index[0] === 'date') {
            if (!isDesc[0]) {
                return (new Date(a.date.ts) - new Date(b.date.ts))
            } else {
                return (new Date(b.date.ts) - new Date(a.date.ts))
            }
          } else if (index[0] === 'status') {
            if (!isDesc[0]) {
              return a.status.name.toLowerCase().localeCompare(b.status.name.toLowerCase())
            } else {
              return b.status.name.toLowerCase().localeCompare(a.status.name.toLowerCase())
            }
          } else if (index[0] === 'customID') {
            if (!isDesc[0]) {
              return a[index[0]].toLowerCase().localeCompare(b.customID.toLowerCase())
            } else {
              return b[index[0]].toLowerCase().localeCompare(a.customID.toLowerCase())
            }
          } else if (index[0] === 'etTotal') {
            if (!isDesc[0]) {
              return parseFloat(a.etTotal) - parseFloat(b.etTotal)
            } else {
              return parseFloat(b.etTotal) - parseFloat(a.etTotal)
            }
          }
        })

        return items
      },
      customFilter(value, search, item) {
        search = search.toString().toLowerCase()
        return item.id.toString().toLowerCase().indexOf(search) > -1 || 
          item.customID.toString().toLowerCase().indexOf(search) > -1 || 
          item.date.formatted.toString().toLowerCase().indexOf(search) > -1 || 
          item.status.name.toString().toLowerCase().indexOf(search) > -1 ||
          item.etTotal.toString().toLowerCase().indexOf(search) > -1
      },
      goToOrder(id) {
        this.$router.push({
          name: 'ShowOrder', 
          params: {
            id: id,
          },
        })
      }
    },

    created() {
      EventBus.$emit(LOADING, 'Chargement des commandes')
      this.getOrders()
    }
  }
</script>

<style scoped>
  .fs12 {
    font-size: 12px;
  }
  .clickable > td:hover {
    cursor: pointer;
  }
</style>